import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';
import { formatToBRDecimal } from '../../Util/number';

const useLineChart = ({ values, subtitles, category, percentual, decimals = 2 }) => {
    const formatValue = (value) => {
        const formatted = formatToBRDecimal(value, decimals);

        return percentual ? `${formatted}%` : formatted;
    };

    let series = [];

    if (Array.isArray(category)) {
        series = category.map((item, index) => {
            return {
                name: item,
                data: values[index]
            };
        });
    } else {
        series = [
            {
                name: category,
                data: values
            }
        ];
    }

    const chartConfig = {
        series,
        colors: defaultColors,
        chart: {
            type: 'line',
            height: 400,
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 2000
            }
        },
        xaxis: {
            categories: subtitles,
            title: {
                style: {
                    fontSize: '16px',
                    color: '#333'
                }
            },
            axisBorder: {
                show: true,
                color: '#333'
            },
            axisTicks: {
                show: true,
                color: '#333'
            },
            labels: {
                style: {
                    fontSize: '14px',
                    colors: '#333'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (value) => formatValue(value),
                style: {
                    fontSize: '14px',
                    colors: '#333'
                }
            },
            grid: {
                show: true,
                borderColor: '#e0e0e0'
            }
        },
        legend: {
            show: true,
            position: 'bottom',
            markers: {
                shape: 'square'
            },
            labels: {
                useSeriesColors: true,
                style: {
                    fontSize: '14px'
                }
            }
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '14px'
            },
            y: {
                formatter: (value) => formatValue(value)
            }
        },
        grid: {
            show: false
        }
    };

    return {
        chartConfig
    };
};

export default useLineChart;
